import buttons_styles from '../../styles/buttons.module.scss';

function ToggleButtonsGroup({ children, vertical = false }) {
  const groupClassName = vertical
    ? 'bim_button_group--vertical'
    : 'bim_button_group';

  return <div className={buttons_styles[groupClassName]}>{children}</div>;
}

export default ToggleButtonsGroup;